import { Link } from '@inertiajs/react';
import { route } from '../../utils/route';
import type { ProductListing } from '../../types/products';

interface RelatedChipsProps {
  products: ProductListing[];
}

export function RelatedChips({ products }: RelatedChipsProps) {
  if (products.length === 0) return null;

  return (
    <div className="mt-4 flex flex-wrap items-center gap-2">
      <span className="text-sm text-gray-500">También te puede interesar:</span>
      {products.map(p => (
        <Link
          key={p.id}
          href={route('product.show', { slug: p.slug })}
          className="rounded-full border border-gray-300 bg-white px-3 py-1 text-sm text-gray-700 no-underline transition-colors hover:border-green-500 hover:text-green-700"
        >
          {p.title}
        </Link>
      ))}
    </div>
  );
}
